import React, { useEffect, useState } from "react";
import Backdrop from "@material-ui/core/Backdrop";
import style from "../../LeftNavigation/DesignerControls/BasicControls.module.css";
import ELEMENT from "../../../UI/BasicFormControls/ELEMENT";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import {
  getGdToken,
  getWIToken,
  setMandatoryControls,
  updatePartialJSON,
  updateRenderState,
} from "../../../components/IFormDesignerLayout/IFormDesignerLogic";

import {
  sendSaveAndClose,
  modifyCallForAdvanceListview,
  addRowAdvanceListview,
  clearAdvanceListview,
} from "../../IFormDesignerLayout/RequestLogic";
import { useDispatch } from "../../../Redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import cloneDeep from "lodash-es/cloneDeep";
import CustomizedAlert from "../../../ReusableComponents/Alert/CustomizedAlert";
import { functions } from "../ApplicationAPI/applicationApi";
import {
  updateContextsStates,
  updateGridContexts,
} from "../../../Redux/Actions/FormStateActions";
import { GetState, GetStateFromData } from "../../CustomHooks/CustomHooks";
import { handleFocus, getHooksId   } from "../../../Resources/globalFunctions";
import { useAdvModalStyles } from "./GridModalStyle/advModalStyle";
import GridModalHeader from "../../../UI/BasicFormControls/TableComponent/GridModalHeader";
import GridModalFooter from "../../../UI/BasicFormControls/TableComponent/GridModalFooter";
import { triggerEventCalls } from "../../../ReusableComponents/Events/EventExecutionLogic";

export default function AdvanceListviewPopUp(props) {
  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification",
  });
  const contexts = GetStateFromData(props.containerId);
  const gridContexts = GetStateFromData(props.containerId, "data2");
  // const { renderAdvanceListView, openSubformCheck, openCanvasForPreviewAdvance } = GetState(
  //   "renderAdvanceListView",
  //   "openSubformCheck",
  //   "openCanvasForPreviewAdvance"
  // );

  const {
    listViewAddRecordFrom,
    currentAdvanceListviewStateJson,
    advSaveAndContinue,
    selectedRowIndexAdvance,
    dataOfAdvFrom,
  } = gridContexts.gridStates;

  const {
    setRecordCount,
    showAlertConfirmNotifications,
    formState2,
    imageBaseURL,
  } = contexts.contexts;

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [refreshCount, setRefreshCount] = useState(0);

  const themeData = formState2.theme;
  const controlThemeData = themeData?.["ButtonStyle"] || {};

  const showFooter = props?.data?.popupStyle?.["ShowFooter"] !== "false";
  const showFooterWhenDisabled = props?.data?.popupStyle?.["ShowFooterWhenDisabled"] !== "false";

  const classes = useAdvModalStyles({
    ...{
      primaryColor: `${
        controlThemeData["PrimaryButtonFontColor"] || "#fff"
      } !important`,
      primaryBackgroundColor: `${
        controlThemeData["PrimaryButtonBackgroundColor"] ||
        "var(--button_color)"
      } !important`,
      primaryBorderColor: `${
        controlThemeData["PrimaryButtonBorderColor"] || "var(--button_color)"
      } !important`,
      secondaryColor: `${
        controlThemeData["SecondaryButtonFontColor"] || "var(--button_color)"
      } !important`,
      secondaryBorderColor: `${
        controlThemeData["SecondaryButtonBorderColor"] || "var(--button_color)"
      } !important`,
    },
    gridStyle: props?.subFormListviewJson?.style || {},
    popupStyle: props?.subFormListviewJson?.popupStyle || {}
  });

  // const [initialFormJson, setInitialFormJson] = useState(
  //   cloneDeep(currentAdvanceListviewStateJson?.listviewFrameLayoutJson || {}) || {}
  // );

  useEffect(() => {
    document.querySelector('[id*="_advListview_crossIcon"]')?.focus();
  }, [refreshCount, document.querySelector('[id*="_advListview_crossIcon"]')]);

  useEffect(() => {
    requestAnimationFrame(() => {
      if (window.listViewLoad) {
        window.listViewLoad(
          getHooksId(currentAdvanceListviewStateJson),
          currentAdvanceListviewStateJson?.modalType
        );
        functions.updateJSON();
      }
      const e = { type: "load" };
      if (
        props?.data &&
        props?.data?.event &&
        props?.data?.event.Events &&
        props?.data?.event.Events.load
      ) {
        triggerEventCalls(
          e,
          { id: props?.data?.id },
          props?.data?.event,
          "form",
          () => {},
          contexts,
          props.containerId,
          props.data,
          "load"
        );
      }
    })

  }, [refreshCount]);

  // useEffect(() => {
  //   setInitialFormJson(cloneDeep(currentAdvanceListviewStateJson?.listviewFrameLayoutJson || {}));
  // }, [currentAdvanceListviewStateJson?.listviewFrameLayoutJson]);

  const callOnClose = () => {
    // if (window.postHookPickListCancel) {
      //   window.postHookPickListCancel(props.data.id);
    // }
    var jsonToSendClearAdvance = {
      gdtoken: getGdToken(),
      controlId: currentAdvanceListviewStateJson.id,
    };
    clearAdvanceListview(jsonToSendClearAdvance)
      .then(() => {
        if (props?.isAdvanceListviewModalOpened?.current === props?.subFormListviewJson?.id) {
          props.isAdvanceListviewModalOpened.current = 0;
        }
        dispatch(
          updateContextsStates({
            key: props.containerId,
            value: {
              listViewAddRecordFrom: false,
              selectedRowIndex: -1,
              currentAdvanceListviewStateJson: undefined,
              advanceListviewStateJson: undefined,
              openCanvasForPreviewAdvance: "",
              openCanvasForPreview: ""
            }
          })
        );
        props.setOpen(false);
        setMandatoryControls([]);

        setLoading(false);
        handleFocus(`${props.subFormListviewJson?.id}_add_record_btn`);
      })
      .catch(() => setLoading(false));
  };

  const closeAdv = () => {
      var jsonToSendClearAdvance = {
        gdtoken: getGdToken(),
        controlId: currentAdvanceListviewStateJson.id,
        rowIndex:"-3"
      };
      clearAdvanceListview(jsonToSendClearAdvance)
        .then(() => {
          if (props?.isAdvanceListviewModalOpened?.current === props?.subFormListviewJson?.id) {
            props.isAdvanceListviewModalOpened.current = 0;
          }
          dispatch(
            updateContextsStates({
              key: props.containerId,
              value: {
                listViewAddRecordFrom: false,
                selectedRowIndex: -3,
                currentAdvanceListviewStateJson: undefined,
                advanceListviewStateJson: undefined,
                openCanvasForPreviewAdvance: "",
                openCanvasForPreview: ""
              }
            })
          );
          props.setOpen(false);
          setMandatoryControls([]);

          setLoading(false);
          handleFocus(`${props.subFormListviewJson?.id}_add_record_btn`);
        })
        .catch(() => setLoading(false));
  }

  function handleClose() {
    setLoading(true);
    if (window.msgOnCloseOverlay) {
      const closeOverlayMessage = window.msgOnCloseOverlay(props?.subFormListviewJson?.id);
      functions.updateJSON();

      if (props?.isAdvanceListviewModalOpened?.current === props?.subFormListviewJson?.id) {
        props.isAdvanceListviewModalOpened.current = 0;
      }
      if (typeof closeOverlayMessage === "string"  && closeOverlayMessage !== "") {
        setAlertData({
          open: true,
          showConfirm: "showconformationDialogBox",
          alertContentKey: closeOverlayMessage,
          Button1Key: "Ok"
        });
      } else if (closeOverlayMessage === true || closeOverlayMessage === undefined || closeOverlayMessage == "") {
        closeAdv();
      }
      setLoading(false);
    } else {
      closeAdv();
    }
  }

  async function addRowInAdvanceListview() {
    setLoading(true);

    const mandatoryValidationResult = window.isComponentValidated(
      "buttonSubform",
      {
        ...currentAdvanceListviewStateJson?.listviewFrameLayoutJson,
        validationType: "advancelistview",
        validationId:
          currentAdvanceListviewStateJson?.listviewFrameLayoutJson
            ?.advancelistviewId,
      }
    );
    if (!mandatoryValidationResult) {
      setLoading(false);
      return;
    }

    var jsonToSend = {
      witoken: getWIToken(props.containerId),
      controlId: currentAdvanceListviewStateJson.id,
      gdtoken: getGdToken(props.containerId),
    };

    let customValidationResult = true;
    if (window.customListViewValidation) {
      const hooksId = getHooksId(currentAdvanceListviewStateJson);
      customValidationResult = await window.customListViewValidation(
        hooksId,
        "A",
        "AddRow"
      );
      functions.updateJSON();
    }

    if (customValidationResult) {
      requestAnimationFrame(() => {
        sendSaveAndClose(jsonToSend).then((response) => {
          if (response?.data?.status === "0") {
            window.setFormMoified(true);
            if (!Object.keys(props.subFormListviewJson).includes("rowData")) {
              props.subFormListviewJson["rowData"] = [];
            }
            var rowData = {};
            rowData = response.data.valueJson;

            const logs1 = { console: "log1", rowData, response, props };
            console.log("consoleAdv1--> ", logs1);

            props.subFormListviewJson.rowData.push(rowData);
            props.data.rowData = [...props.subFormListviewJson.rowData];

            const logs2 = { console: "log2", rowData, response, props };
            console.log("consoleAdv2--> ", logs2);

            if (props?.subFormListviewJson?.style) {
              props.subFormListviewJson.style["updateFormState"] = new Date();
            }
            updatePartialJSON(
              props.subFormListviewJson.id,
              props.subFormListviewJson,
              true
            );

            const logs3 = { console: "log3", rowData, response, props };

            var jsonToSendClearAdvance = {
              gdtoken: getGdToken(),
              controlId: currentAdvanceListviewStateJson.id,
              rowIndex: "-2"
            };
            clearAdvanceListview(jsonToSendClearAdvance)
              .then((res) => {
                // if (window.addRowPostHook) {
                //   window.addRowPostHook(props.subFormListviewJson.id, "manual");
                //   functions.updateJSON();
                // }
              })
              .catch(() => setLoading(false));
            setRecordCount(props.subFormListviewJson.id, true);
            dispatch(
              updateContextsStates({
                key: props.containerId,
                value: {
                  listViewAddRecordFrom: false,
                  advanceListviewStateJson: undefined,
                  openCanvasForPreviewAdvance: "",
                  currentAdvanceListviewStateJson: undefined,
                  openCanvasForPreview: "",
                },
                // renderAdvListView: true
              })
            );
            // setTimeout(() => {
            //   dispatch(
            //     updateGridContexts({ name: "currentAdvanceListviewStateJson", key: props.containerId, value: undefined })
            //   );
            // }, 500);
            if (
              props?.isAdvanceListviewModalOpened?.current ===
              props?.subFormListviewJson?.id
            ) {
              props.isAdvanceListviewModalOpened.current = 0;
            }

            props.setOpen(false);
            setLoading(false);
            handleFocus(`${props.subFormListviewJson?.id}_add_record_btn`);
            // props.setTableData(props.data);
            props.setRenderCount((prev) => prev + 1);
            const logs4 = { console: "log4", rowData, response, props };
            console.log("consoleAdv4--> ", logs4);

            if (window.addRowPostHook) {
              window.addRowPostHook(getHooksId(props?.subFormListviewJson), "manual");
              functions.updateJSON();
            }
            const logs5 = { console: "log5", rowData, response, props };
            console.log("consoleAdv5--> ", logs5);
          } else if (response?.data?.status === "-1") {
            showServerError(false, "DUPLICATE_ROW_MESSAGE");
          } else if (response?.data?.status === "-2") {
            showServerError(false, "INVALID_DATA_MESSAGE");
          } else if (response?.data?.status === "-3") {
            showServerError(false, "Column mapping is not done");
          }
        });
      });
    } else {
      setLoading(false);
    }
  }

  async function addRowInAdvanceListviewSaveAndContinue() {
    setLoading(true);

    const mandatoryValidationResult = window.isComponentValidated(
      "buttonSubform",
      {
        ...currentAdvanceListviewStateJson?.listviewFrameLayoutJson,
        validationType: "advancelistview",
        validationId:
          currentAdvanceListviewStateJson?.listviewFrameLayoutJson
            ?.advancelistviewId,
      }
    );
    if (!mandatoryValidationResult) {
      setLoading(false);
      return;
    }
    var jsonToSend = {
      witoken: getWIToken(),
      controlId: currentAdvanceListviewStateJson.id,
      gdtoken: getGdToken(),
    };
    let customValidationResult = true;
    if (window.customListViewValidation) {
      customValidationResult = await window.customListViewValidation(
        getHooksId(currentAdvanceListviewStateJson),
        "A",
        "AddRow"
      );
      functions.updateJSON();
    }
    if (customValidationResult) {
      sendSaveAndClose(jsonToSend)
        .then((response) => {
          if (response?.data?.status === "0") {
            window.setFormMoified(true);
            if (!Object.keys(props.subFormListviewJson).includes("rowData")) {
              props.subFormListviewJson["rowData"] = [];
              var rowData = {};
            }
            rowData = response.data.valueJson;
            props.subFormListviewJson.rowData.push(rowData);
            props.data.rowData = [...props.subFormListviewJson.rowData];

            if (props?.subFormListviewJson?.style) {
              props.subFormListviewJson.style["updateFormState"] = new Date();
            }
            updatePartialJSON(
              props.subFormListviewJson.id,
              props.subFormListviewJson,
              true
            );
            var jsonToSendClearAdvance = {
              gdtoken: getGdToken(),
              controlId: currentAdvanceListviewStateJson.id,
              rowIndex:"-2"
            };
            clearAdvanceListview(jsonToSendClearAdvance)
              .then((res) => {
                var jsonToSend = {
                  rowIndex: "-1",
                  controlId: props.subFormListviewJson.id,
                  modifyflag: "no",
                  witoken: getWIToken(props.containerId),
                  gdtoken: getGdToken(props.containerId),
                  saveAndContinue: "Y",
                };
                addRowAdvanceListview(jsonToSend)
                  .then((response) => {
                    props.subFormListviewJson.listviewFrameLayoutJson =
                      cloneDeep(response.data.ele_JSON.listviewFrameLayoutJson);
                      props.subFormListviewJson.modalType = "A";
                    props.gridPopup(
                      "advanceListviewPopupInPreview",
                      props.subFormListviewJson,
                      true,
                      -1
                    );
                    dispatch(
                      updateGridContexts({
                        key: props.containerId,
                        name: "advSaveAndContinue",
                        value: !advSaveAndContinue,
                      })
                    );
                    setLoading(false);

                    if (window.addRowPostHook) {
                      window.addRowPostHook(
                        getHooksId(props?.subFormListviewJson),
                        "manual"
                      );
                      functions.updateJSON();
                    }

                    setRefreshCount((prev) => prev + 1);
                  })
                  .catch((err) => {
                    console.log(err);
                    setLoading(false);
                  });
              })
              .catch((err) => {
                console.log(err);
                setLoading(false);
              });
            setRecordCount(props.subFormListviewJson.id, true);
            props.setRenderCount(prev => prev + 1);
            // setRefreshCount((prev) => prev + 1);
          } else if (response?.data?.status === "-1") {
            setLoading(false);
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: "DUPLICATE_ROW_MESSAGE",
            });
          } else if (response?.data?.status === "-2") {
            setLoading(false);
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentKey: "INVALID_DATA_MESSAGE",
            });
          } else if (response?.data?.status === "-3") {
            setLoading(false);
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              alertContentMsg: `Column mapping is not done for ${response.data.unMappedColumnName}`,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }

  async function previousRowHandler() {
    setLoading(true);
    var currIndex = selectedRowIndexAdvance;

    let result = true;

    if (window.tableOperation) {
      result = window.tableOperation(
        getHooksId(props?.subFormListviewJson),
        "PreviousRow"
      );
      functions.updateJSON();
    }

    let customValidationResult = true;
    if (window.customListViewValidation) {
      customValidationResult = await window.customListViewValidation(
        getHooksId(currentAdvanceListviewStateJson),
        "M",
        "PreviousRow"
      );
      functions.updateJSON();
    }

    if ((result || result === undefined) && customValidationResult) {
      var jsonToSend = {
        witoken: getWIToken(),
        controlId: props.subFormListviewJson.id,
        gdtoken: getGdToken(),
        rowIndex: currIndex,
      };

      const extraRowData = window?.currentRowData;
      modifyCallForAdvanceListview(jsonToSend).then((response) => {
        if (response?.data?.status === "0") {
          window.setFormMoified(true);
          setRecordCount(props.subFormListviewJson.id, true);

          const rowData = response.data.valueJson;

          if (extraRowData && extraRowData.id === selectedRowIndexAdvance) {
            for (let key in rowData) {
              if (
                extraRowData.hasOwnProperty(`${rowData[key].name}_extraOptions`)
              ) {
                rowData[key].extraOptions =
                  extraRowData[`${rowData[key].name}_extraOptions`];
              }
              if (
                extraRowData.hasOwnProperty(`${rowData[key].name}_clearOptions`)
              ) {
                rowData[key].clearCombo =
                  extraRowData[`${rowData[key].name}_clearOptions`];
              }
              if (
                extraRowData.hasOwnProperty(
                  `${rowData[key].name}_removeOptionIndex`
                )
              ) {
                rowData[key].removeOptionIndex =
                  extraRowData[`${rowData[key].name}_removeOptionIndex`];
              }
            }
          }

          props.subFormListviewJson.rowData[selectedRowIndexAdvance] = rowData;
          updatePartialJSON(
            props.subFormListviewJson.id,
            props.subFormListviewJson,
            true
          );

          if (props?.subFormListviewJson?.style) {
            props.subFormListviewJson.style["updateFormState"] = new Date();
          }

          handleFocus(`${props.subFormListviewJson?.id}_add_record_btn`);
          // props.setTableData(props.subFormListviewJson);
          if (window.modifyRowPostHook) {
            window.modifyRowPostHook(
              getHooksId(props?.subFormListviewJson),
              selectedRowIndexAdvance
            );
            functions.updateJSON();
          }
          props.setRenderCount((prev) => prev + 1);

          const prevIndex = selectedRowIndexAdvance - 1;

          if (prevIndex >= 0) {
            dispatch(
              updateGridContexts({
                key: props.containerId,
                name: "selectedRowIndexAdvance",
                value: prevIndex,
              })
            );

            const addJsonToSend = {
              rowIndex: prevIndex,
              controlId: props.subFormListviewJson.id,
              modifyFlag: "yes",
              witoken: getWIToken(),
              gdtoken: getGdToken(),
            };

            addRowAdvanceListview(addJsonToSend).then((response) => {
              if (response.data.ele_JSON !== undefined) {
                dispatch(
                  updateGridContexts({
                    name: "currentAdvanceListviewStateJson",
                    key: props.containerId,
                    value: {
                      ...response.data.ele_JSON,
                      rowData: props?.subFormListviewJson?.rowData || [],
                      style: { ...(response?.data?.ele_JSON?.style || {}), GridModalType: response?.data?.ele_JSON?.style?.GridModalType || "modal" },
                      modalType:"M",
                    },
                    renderAdvListView: true,
                  })
                );
              }
              //custom hook when user click on Next or Previos Button
              if (window.nextPreviousAdvancedListviewPosthook) {
                window.nextPreviousAdvancedListviewPosthook(
                  getHooksId(props?.subFormListviewJson),
                  currIndex,
                  "Previous"
                );
                functions.updateJSON();
              }
              setTimeout(() => {
                setLoading(false);
              }, 150);
              setRefreshCount((prev) => prev + 1);
            }).catch((err) => {
              console.log(err);
              setLoading(false);
            });
          } else {
            setLoading(false);
          }
          dispatch(
            updateGridContexts({
              key: props.containerId,
              name: "listviewClearState",
              value: true,
            })
          );
        } else if (response?.data?.status === "-1") {
          showServerError(false, "DUPLICATE_ROW_MESSAGE");
        } else if (response?.data?.status === "-2") {
          showServerError(false, "INVALID_DATA_MESSAGE");
        } else if (response?.data?.status === "-3") {
          showServerError(false, "Column mapping is not done");
        }
      }).catch((err) => {
        console.log(err);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }

  async function nextRowHandler() {
    setLoading(true);
    var currIndex = selectedRowIndexAdvance;

    let result = true;

    if (window.tableOperation) {
      result = window.tableOperation(getHooksId(props?.subFormListviewJson), "NextRow");
      functions.updateJSON();
    }

    let customValidationResult = true;
    if (window.customListViewValidation) {
      customValidationResult = await window.customListViewValidation(
        getHooksId(currentAdvanceListviewStateJson),
        "M",
        "NextRow"
      );
      functions.updateJSON();
    }

    if ((result || result === undefined) && customValidationResult) {
      var jsonToSend = {
        witoken: getWIToken(),
        controlId: props.subFormListviewJson.id,
        gdtoken: getGdToken(),
        rowIndex: currIndex,
      };

      const extraRowData = window?.currentRowData;
      modifyCallForAdvanceListview(jsonToSend).then((response) => {
        if (response?.data?.status === "0") {
          window.setFormMoified(true);
          setRecordCount(props.subFormListviewJson.id, true);

          const rowData = response.data.valueJson;

          if (extraRowData && extraRowData.id === selectedRowIndexAdvance) {
            for (let key in rowData) {
              if (
                extraRowData.hasOwnProperty(`${rowData[key].name}_extraOptions`)
              ) {
                rowData[key].extraOptions =
                  extraRowData[`${rowData[key].name}_extraOptions`];
              }
              if (
                extraRowData.hasOwnProperty(`${rowData[key].name}_clearOptions`)
              ) {
                rowData[key].clearCombo =
                  extraRowData[`${rowData[key].name}_clearOptions`];
              }
              if (
                extraRowData.hasOwnProperty(
                  `${rowData[key].name}_removeOptionIndex`
                )
              ) {
                rowData[key].removeOptionIndex =
                  extraRowData[`${rowData[key].name}_removeOptionIndex`];
              }
            }
          }

          props.subFormListviewJson.rowData[selectedRowIndexAdvance] = rowData;
          updatePartialJSON(
            props.subFormListviewJson.id,
            props.subFormListviewJson,
            true
          );

          if (props?.subFormListviewJson?.style) {
            props.subFormListviewJson.style["updateFormState"] = new Date();
          }

          handleFocus(`${props.subFormListviewJson?.id}_add_record_btn`);
          // props.setTableData(props.subFormListviewJson);
          if (window.modifyRowPostHook) {
            window.modifyRowPostHook(
              getHooksId(props?.subFormListviewJson),
              selectedRowIndexAdvance
            );
            functions.updateJSON();
          }
          props.setRenderCount((prev) => prev + 1);

          const nextIndex = selectedRowIndexAdvance + 1;
          const totalRowLength = props.subFormListviewJson.rowData.length;

          if (nextIndex <= totalRowLength) {
            dispatch(
              updateGridContexts({
                key: props.containerId,
                name: "selectedRowIndexAdvance",
                value: nextIndex,
              })
            );

            const addJsonToSend = {
              rowIndex: nextIndex,
              controlId: props.subFormListviewJson.id,
              modifyFlag: "yes",
              witoken: getWIToken(),
              gdtoken: getGdToken(),
            };

            addRowAdvanceListview(addJsonToSend).then((response) => {
              if (response.data.ele_JSON !== undefined) {
                dispatch(
                  updateGridContexts({
                    name: "currentAdvanceListviewStateJson",
                    key: props.containerId,
                    value: { ...response.data.ele_JSON, 
                      modalType: "M",
                      style: { ...(response?.data?.ele_JSON?.style || {}), GridModalType: response?.data?.ele_JSON?.style?.GridModalType || "modal" },
                      rowData: props?.subFormListviewJson?.rowData || [] },
                    renderAdvListView: true
                  })
                );
              }
              //custom hook when user click on Next or Previos Button
              if (window.nextPreviousAdvancedListviewPosthook) {
                window.nextPreviousAdvancedListviewPosthook(getHooksId(props?.subFormListviewJson), currIndex, "Next");
                functions.updateJSON();
              }
              setTimeout(() => {
                setLoading(false);
              }, 150);
              setRefreshCount((prev) =>  prev + 1);
            }).catch((err) => {
              console.log(err);
              setLoading(false);
            });
            dispatch(updateGridContexts({ key: props.containerId, name: "listviewClearState", value: true }));
          } else {
            setLoading(false);
          }
        } else if (response?.data?.status === "-1") {
          showServerError(false, "DUPLICATE_ROW_MESSAGE");
        } else if (response?.data?.status === "-2") {
          showServerError(false, "INVALID_DATA_MESSAGE");
        } else if (response?.data?.status === "-3") {
          showServerError(false, "Column mapping is not done");
        }
      }).catch((err) => {
        console.log(err);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }

  function showServerError(isGlobalError, alertContentKey) {
    if (window.loading && isGlobalError) {
      window.loading(false);
    } else {
      setLoading(false);
    }

    setAlertData({
      open: true,
      showConfirm: "showNotification",
      alertType: "error",
      alertContentKey,
    });
  }

  async function modifyRowHandler() {
    setLoading(true);

    const mandatoryValidationResult = window.isComponentValidated(
      "buttonSubform",
      {
        ...currentAdvanceListviewStateJson?.listviewFrameLayoutJson,
        validationType: "advancelistview",
        validationId:
          currentAdvanceListviewStateJson?.listviewFrameLayoutJson
            ?.advancelistviewId,
      }
    );
    if (!mandatoryValidationResult) {
      setLoading(false);
      return;
    }

    let result = true;
    let customValidationResult = true;
    if (window.customListViewValidation) {
      customValidationResult = await window.customListViewValidation(
        getHooksId(currentAdvanceListviewStateJson),
        "M",
        "ModifyRow"
      );
      functions.updateJSON();
    }

    if (window.tableOperation) {
      result = window.tableOperation(getHooksId(props?.subFormListviewJson), "ModifyRow");
      functions.updateJSON();
    }

    if (result && customValidationResult) {
      var jsonToSend = {
        witoken: getWIToken(),
        controlId: props.subFormListviewJson.id,
        gdtoken: getGdToken(),
        rowIndex: selectedRowIndexAdvance,
      };
      const extraRowData = window?.currentRowData;
      modifyCallForAdvanceListview(jsonToSend).then((response) => {
        if (response?.data?.status === "0") {
          window.setFormMoified(true);
          setRecordCount(props.subFormListviewJson.id, true);

          const rowData = response.data.valueJson;

          if (extraRowData && extraRowData.id === selectedRowIndexAdvance) {
            for (let key in rowData) {
              if (
                extraRowData.hasOwnProperty(`${rowData[key].name}_extraOptions`)
              ) {
                rowData[key].extraOptions =
                  extraRowData[`${rowData[key].name}_extraOptions`];
              }
              if (
                extraRowData.hasOwnProperty(`${rowData[key].name}_clearOptions`)
              ) {
                rowData[key].clearCombo =
                  extraRowData[`${rowData[key].name}_clearOptions`];
              }
              if (
                extraRowData.hasOwnProperty(
                  `${rowData[key].name}_removeOptionIndex`
                )
              ) {
                rowData[key].removeOptionIndex =
                  extraRowData[`${rowData[key].name}_removeOptionIndex`];
              }
            }
          }

          props.subFormListviewJson.rowData[selectedRowIndexAdvance] = rowData;
          props.data.rowData[selectedRowIndexAdvance] = {
            ...props.subFormListviewJson.rowData[selectedRowIndexAdvance],
          };
          updatePartialJSON(
            props.subFormListviewJson.id,
            props.subFormListviewJson,
            true
          );

          if (props?.subFormListviewJson?.style) {
            props.subFormListviewJson.style["updateFormState"] = new Date();
          }

          var jsonToSendClearAdvance = {
            gdtoken: getGdToken(),
            controlId: currentAdvanceListviewStateJson.id,
          };
          console.log(response, "modifyCallForAdvanceListview")
          clearAdvanceListview(jsonToSendClearAdvance)
            .then((res) => {
              //render
              console.log(res, "clearAdvanceListview")
              dispatch(
                updateContextsStates({
                  key: props.containerId,
                  value: {
                    listViewAddRecordFrom: false,
                    listviewClearState: true,
                    selectedRowIndex: -1,
                    advanceListviewStateJson: undefined,
                    currentAdvanceListviewStateJson: undefined,
                    openCanvasForPreview: "",
                    openCanvasForPreviewAdvance: "",
                  },
                  renderAdvListView: true,
                })
              );
              if (window.modifyRowPostHook) {
                window.modifyRowPostHook(
                  getHooksId(props?.subFormListviewJson),
                  selectedRowIndexAdvance
                );
                functions.updateJSON();
              }
              updateRenderState(props.subFormListviewJson?.id);
            })
            .catch(() => setLoading(false));

          setLoading(false);
          handleFocus(`${props.subFormListviewJson?.id}_add_record_btn`);
          props.setRenderCount((prev) => prev + 1);
          if (
            props?.isAdvanceListviewModalOpened?.current ===
            props?.subFormListviewJson?.id
          ) {
            props.isAdvanceListviewModalOpened.current = 0;
          }
          props.setOpen(false);
        } else if (response?.data?.status === "-1") {
          showServerError(false, "DUPLICATE_ROW_MESSAGE");
        } else if (response?.data?.status === "-2") {
          showServerError(false, "INVALID_DATA_MESSAGE");
        } else if (response?.data?.status === "-3") {
          showServerError(false, "Column mapping is not done");
        }
      });
    } else {
      setLoading(false);
    }
  }

  const content = <div
    classes={{ root: classes.dialogContent }}
    style={{ margin:0, backgroundColor: props?.subFormListviewJson?.popupStyle?.["AdvListviewBackgroundColor"] }}
  >
    {currentAdvanceListviewStateJson && currentAdvanceListviewStateJson.listviewFrameLayoutJson !== undefined ? (
      <ELEMENT {...props} containerId={props.containerId} data={(currentAdvanceListviewStateJson?.listviewFrameLayoutJson || {})} />
    ) : null}
  </div>

    const dialog = <Dialog
      disableEnforceFocus={true}
      disableAutoFocus={true}
      disableRestoreFocus={true}
        open={props.open}
        classes={{ paper: classes.dialog, root: classes.root }}
        onClose={(event, reason) => {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            handleClose();
          }
        }}
        container={() => document.getElementById("canvasId")}
        className="formBuilder_main_app"
        style={{ zIndex: 1298 }}
        key={props?.subFormListviewJson?.id}
        id={`${props.subFormListviewJson.id}_advListviewPopup`}
        aria-labelledby={`${props?.subFormListviewJson.id}_advListview_label`}
      >
        <GridModalHeader
          gridJSON={props.subFormListviewJson}
          imageBaseURL={imageBaseURL}
          isViewer={true}
          extraProps={{ handleClose }}
          modalType = {props.data.style.GridModalType}

        />

        <DialogContent
          classes={{ root: [classes.dialogContent, "scrollable"].join(" ") }}
          style={{ backgroundColor: props?.subFormListviewJson?.popupStyle?.["AdvListviewBackgroundColor"] }}
        >
          {currentAdvanceListviewStateJson &&
          currentAdvanceListviewStateJson.listviewFrameLayoutJson !==
            undefined ? (
            <ELEMENT
              {...props}
              containerId={props.containerId}
              data={
                currentAdvanceListviewStateJson?.listviewFrameLayoutJson || {}
              }
            />
          ) : null}
        </DialogContent>

        <Backdrop
          open={loading}
          className={[classes.backdrop, style.listviewLoaderBackdrop].join(" ")}
        >
          <CircularProgress size={30} />
          {/* <span className={style.listviewLoadingText}>loading...</span> */}
        </Backdrop>

        {showFooter && (showFooterWhenDisabled || props?.data?.style?.Enable !== "false") ? (
        <GridModalFooter
          modalType = {props.data.style.GridModalType}
          gridJSON={props.subFormListviewJson}
          formState2={formState2}
          isViewer={true}
          extraProps={{
            handleClose,
            loading: loading,
            showOverlayBatchButtonPartial: !listViewAddRecordFrom,
            nextClick: nextRowHandler,
            previousClick: previousRowHandler,
            saveAndContinue: addRowInAdvanceListviewSaveAndContinue,
            saveAndClose: addRowInAdvanceListview,
            saveChanges: modifyRowHandler,
            selectedRowIndex: selectedRowIndexAdvance,
            dataOfAdvFrom: dataOfAdvFrom,
          }}
        />) : null}
      </Dialog>

  const sectionView = <div className={style.sectionview__container}>
    {
    props?.data.popupStyle?.Header!=="false" &&
    <GridModalHeader
    gridJSON={props.subFormListviewJson}
    imageBaseURL={imageBaseURL}
    isViewer={true}
    extraProps={{ handleClose }}
    modalType = {props.data.style.GridModalType}
    
    />
  }
    {content}
    <Backdrop open={loading} className={[classes.backdrop, style.listviewLoaderBackdrop].join(" ")}>
      <CircularProgress size={30} />
      {/* <span className={style.listviewLoadingText}>loading...</span> */}
    </Backdrop>
    <GridModalFooter
      modalType = {props.data.style.GridModalType}
      gridJSON={props.subFormListviewJson}
      formState2={formState2}
      isViewer={true}
      extraProps={{
        handleClose,
        loading: loading,
        showOverlayBatchButtonPartial: !listViewAddRecordFrom,
        nextClick: nextRowHandler,
        previousClick: previousRowHandler,
        saveAndContinue: addRowInAdvanceListviewSaveAndContinue,
        saveAndClose: addRowInAdvanceListview,
        saveChanges: modifyRowHandler,
        selectedRowIndex: selectedRowIndexAdvance,
        dataOfAdvFrom: dataOfAdvFrom
      }}
    />
  </div>


return (
   <div>
      {props.data.style.GridModalType === 'modal' || props.data.style.GridModalType === undefined ? dialog : sectionView }
      {alertData.open === true && <CustomizedAlert alertData={alertData} callOnClose={closeAdv} />}
    </div>
  );
}
